import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import Contactbanner from "../../assets/images/noting-client-requirements.avif";
import { FaSearch } from "react-icons/fa";
import "../../../src/App.css";
import { IoMdMail } from "react-icons/io";
import CustomBanner from "../../components/CustomBanner";
import { routes } from "../../config/utilities/utils.constant";
import { Link } from "react-router-dom";
import Captcha from "../../components/Captcha";
import ContactForm from "../../components/ContactForm";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";

function ContactUs() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <>
      <Head>
        <title>Get in touch with us!</title>
        <meta
          name="description"
          content="Submit your inquiry, request a quotation for your project or schedule a discovery call. "
        />
        <link rel="canonical" href="https://apptalyst.com/contact-us " />
      </Head>
      <CustomBanner bgImg={Contactbanner}>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-[36px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1] font-bold "
        >
          Contact Us
        </motion.h1>
      </CustomBanner>
      <div className="  bg-gray-50 py-20 md:py-32">
        <div className="container ">
          <div className="mb-4 block md:hidden ">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-2xl font-bold text-center  text-dark"
            >
              Schedule a free consultation & brainstorming session.{" "}
            </motion.h2>
          </div>
          <div className="flex flex-col-reverse md:flex-row space-x-1 lg:space-x-10">
            <div className="md:w-2/5 space-y-4 px-4 pt-10  bg-re-900 flex flex-col justifycenter">
              <div className="space-y-5">
                <div className="mb-4 hidden md:block ">
                  <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true, amount: 0.3 }}
                    className=" text-[30px] xl:text-[33px] 2xl:text-[40px] font-bold text-dark"
                  >
                    Schedule a free consultation & brainstorming session.
                  </motion.h2>
                </div>

                <div className="space-y-4  pt-10">
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-dark">
                      Mailing Address
                    </h3>
                    <div className="flex  items-start space-x-1">
                      <FaMapMarkerAlt className="text-2xl text-dark mt-1" />
                      <p className="text-lg font-bold text-dark">
                        11819 Thomas Ave, Great Falls, VA, 22066, USA.
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>
                <div className="space-y-4 ">
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-dark">Email</h3>
                    <div className="flex  items-center space-x-1">
                      <a
                        href="mailto:info@apptalyst.com"
                        aria-label="Send an email to Apptalyst at info@apptalyst.com"
                      >
                        <IoMdMail className="text-2xl text-dark" />
                      </a>
                      <p className="text-lg font-bold text-dark">
                        <a href="mailto:info@apptalyst.com">
                          info@apptalyst.com
                        </a>
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>
                <div className="space-y-4">
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-dark">Phone</h3>
                    <div className="flex  items-center space-x-1">
                      <a href="tel:+7034703094">
                        <FaPhoneAlt className="text-2xl text-dark" />
                      </a>
                      <p className="text-lg font-bold text-dark">
                        <a
                          href="tel:+17033812998"
                          aria-label="Call Apptalyst at (703) 381-2998"
                        >
                          (703) 381-2998
                        </a>
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-dark">Working hours</h3>
                <div className="flex text-xl font-semibold text-dark">
                  <p>Mon-Fri : &nbsp;</p>
                  <p> 8:00am-5:00pm EST</p>
                </div>
                <div className="flex text-xl font-semibold text-dark">
                  <p>Sat & Sun : &nbsp; </p>
                  <p> Closed</p>
                </div>
              </div>
            </div>
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  );
}
export default ContactUs;
